import { useEffect, useRef, useState } from 'react';
import './SearchableDropdown.scss';

const SearchableDropdown = ({ options, label, selectedVal, handleChange }) => {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', toggle);
    return () => document.removeEventListener('click', toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => '');
    handleChange(option);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    // console.log(selectedVal);
    if (query) return query;
    if (selectedVal) return options.find((option) => option.id === selectedVal).name;

    return '';
  };

  const filter = (options) => {
    return options.filter((option) => option.name.toLowerCase().indexOf(query.toLowerCase()) > -1);
  };

  return (
    <div className="tmx-searchableDropdown__dropdown">
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={getDisplayValue()}
            placeholder={label}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value);
              handleChange();
            }}
            onClick={toggle}
          />
        </div>
        <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
      </div>

      <div className={`options ${isOpen ? 'open' : ''}`}>
        {filter(options).map((option, index) => {
          return (
            <div
              onClick={() =>
                selectOption({ id: option.id, verification_type: option.verification_type })
              }
              className={`option ${option.name === selectedVal ? 'selected' : ''}`}
              key={index}>
              {option.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchableDropdown;
